import ReactDOM from "react-dom/client";
import "./assets/styles/index.scss";
import "./common";
import App from "./App";
import { HashRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <HashRouter>
    <App />
  </HashRouter>
);
